module.exports = __webpack_public_path__ + "img/track.11b70e15.svg";